module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.ffExportDetail.containerInfo == "lcl" ?
    "Execution-LCL Consolidation" :
    "Execution-FCL Consolidation"))])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.WarehouseStuffing.allModuleId ? _vm.WarehouseStuffing.allModuleId : '',
      "jobSeriesBanner": _vm.WarehouseStuffing.ffExportFclConsoSeries ?
        _vm.WarehouseStuffing.ffExportFclConsoSeries :
        '',
      "bannerClientName": _vm.WarehouseStuffing.clientName ? _vm.WarehouseStuffing.clientName : '',
      "trackingId": _vm.trackingId != '' ? _vm.trackingId : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [(_vm.WarehouseStuffing.allModuleId) ? _c('ContainerComponent', {
    attrs: {
      "allModuleIdContainer": _vm.WarehouseStuffing.allModuleId ? _vm.WarehouseStuffing.allModuleId : '',
      "JOB": "FF"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.proceedNext == '1') ? _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', [_c('b', [_c('u', [_vm._v(_vm._s(_vm.ffExportDetail.portType == "Icd" ?
    "Warehouse Stuffing At ICD" :
    " Warehouse Stuffing At PORT"))])])])])], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Name of CFS Where Stuffing is done")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "nameOfCFS",
      "id": "nameOfCFS"
    },
    model: {
      value: (_vm.WarehouseStuffing.nameOfCFS),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "nameOfCFS", $$v)
      },
      expression: "WarehouseStuffing.nameOfCFS"
    }
  })], 1), _vm._v(" "), (!_vm.WarehouseStuffing.nameOfCFS) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMainExecution.nameOfCFS))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Cargo Stuffing Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "cargoStuffingDate",
      "id": "cargoStuffingDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.WarehouseStuffing.cargoStuffingDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "cargoStuffingDate", $$v)
      },
      expression: "WarehouseStuffing.cargoStuffingDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Handover Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "handoverDate",
      "id": "handoverDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.WarehouseStuffing.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "handoverDate", $$v)
      },
      expression: "WarehouseStuffing.handoverDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("VGM Submission Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "vgmSubmissionDate",
      "id": "vgmSubmissionDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.WarehouseStuffing.vgmSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "vgmSubmissionDate", $$v)
      },
      expression: "WarehouseStuffing.vgmSubmissionDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "gateInDate"
    }
  }, [_vm._v("SI Submission date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "id": "gateInDate",
      "type": "datetime",
      "minute-step": 1,
      "name": "gateInDate"
    },
    model: {
      value: (_vm.WarehouseStuffing.siSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "siSubmissionDate", $$v)
      },
      expression: "WarehouseStuffing.siSubmissionDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "trSubmissionDate"
    }
  }, [_vm._v("TR Submission date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "id": "trSubmissionDate",
      "type": "datetime",
      "minute-step": 1,
      "name": "trSubmissionDate"
    },
    model: {
      value: (_vm.WarehouseStuffing.trSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "trSubmissionDate", $$v)
      },
      expression: "WarehouseStuffing.trSubmissionDate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.clientList.length > 0 || _vm.clientDataModel.execConClientId != '') ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), (_vm.clientList.length > 0 || _vm.clientDataModel.execConClientId != '') ? _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "95"
    }
  }, [_c('label', [_c('b', [_c('u', [_vm._v("\n                        Client Details\n                        "), (_vm.sbDetailArrayList.length == 0) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAtleastSb))]) : _vm._e()])])])])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.clientDataModel.execConClientId == '') ? _c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Existing Client Name")]) : _vm._e(), _vm._v(" "), (_vm.clientDataModel.execConClientId == '') ? _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Client Name"
    },
    model: {
      value: (_vm.clientDataModel.clientId),
      callback: function($$v) {
        _vm.$set(_vm.clientDataModel, "clientId", $$v)
      },
      expression: "clientDataModel.clientId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Existing Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.clientDataModel.clientName),
      callback: function($$v) {
        _vm.$set(_vm.clientDataModel, "clientName", $$v)
      },
      expression: "clientDataModel.clientName"
    }
  })], 1), _vm._v(" "), (!_vm.clientDataModel.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorClientList.clientId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Carting Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "cartingDate",
      "id": "cartingDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.clientDataModel.cartingDate),
      callback: function($$v) {
        _vm.$set(_vm.clientDataModel, "cartingDate", $$v)
      },
      expression: "clientDataModel.cartingDate"
    }
  }), _vm._v(" "), (!_vm.clientDataModel.cartingDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorClientList.cartingDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CRN (Carting Order)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "crnNumber",
      "id": "crnNumber"
    },
    model: {
      value: (_vm.clientDataModel.crnNumber),
      callback: function($$v) {
        _vm.$set(_vm.clientDataModel, "crnNumber", $$v)
      },
      expression: "clientDataModel.crnNumber"
    }
  })], 1), _vm._v(" "), (!_vm.clientDataModel.crnNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorClientList.crnNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Client VGM")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "vgmUpload",
      "id": "vgmUpload",
      "multiple": ""
    },
    model: {
      value: (_vm.clientDataModel.vgmUpload),
      callback: function($$v) {
        _vm.$set(_vm.clientDataModel, "vgmUpload", $$v)
      },
      expression: "clientDataModel.vgmUpload"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "variant": "outline-info",
      "id": "addButtonLoaderC"
    },
    on: {
      "click": _vm.addClientWithMain
    }
  }, [_vm._v(_vm._s(_vm.clientDataModel.execConClientId == "" ? "Add" : "Edit") + "\n                    Client")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderC"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getMultipleClientArry.length > 0) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), (_vm.getMultipleClientArry.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("Client Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ffConClient"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Carting Date")]), _vm._v(" "), _c('th', [_vm._v("CRN")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getMultipleClientArry), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEdit(item)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.myclientName) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.cartingDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.crnNumber))])])
  }))])])]) : _vm._e(), _vm._v(" "), (
    _vm.sbLengthforAll.length == _vm.getMultipleClientArry.length &&
    _vm.getMultipleClientArry.length > 0
  ) ? _c('md-layout', {
    staticClass: "gutr mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }), _vm._v(" "), (
    _vm.sbLengthforAll.length == _vm.getMultipleClientArry.length &&
    _vm.getMultipleClientArry.length > 0
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.showMoreSBDet
    }
  }, [_vm._v(_vm._s(_vm.showMoreSB == true ? "Hide" :
    "Add More") + " S/B")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    (_vm.sbLengthforAll.length != _vm.getMultipleClientArry.length &&
      _vm.getMultipleClientArry.length > 0) ||
    _vm.showMoreSB ||
    _vm.SBDetail.conshippingSBId != ''
  ) ? _c('div', [_c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "1%"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "95"
    }
  }, [_c('label', [_c('b', [_c('u', [_vm._v("\n                        Client Shipping Details\n                        "), (_vm.sbDetailArrayList.length == 0) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAtleastSb))]) : _vm._e()])])])])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientListSbDetail,
      "id": "clientId",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.SBDetail.clientId),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "clientId", $$v)
      },
      expression: "SBDetail.clientId"
    }
  }), _vm._v(" "), (!_vm.SBDetail.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.clientId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Shipping Bill Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "shippingBillDate",
      "id": "shippingBillDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.shippingBillDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "shippingBillDate", $$v)
      },
      expression: "SBDetail.shippingBillDate"
    }
  }), _vm._v(" "), (!_vm.SBDetail.shippingBillDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.shippingBillDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "shippingBillNo",
      "id": "shippingBillNo"
    },
    model: {
      value: (_vm.SBDetail.shippingBillNo),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "shippingBillNo", $$v)
      },
      expression: "SBDetail.shippingBillNo"
    }
  })], 1), _vm._v(" "), (!_vm.SBDetail.shippingBillNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.shippingBillNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Cargo Gross Weight(tons)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "cargoGrossWeight",
      "id": "cargoGrossWeight"
    },
    model: {
      value: (_vm.SBDetail.cargoGrossWeight),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "cargoGrossWeight", $$v)
      },
      expression: "SBDetail.cargoGrossWeight"
    }
  })], 1), _vm._v(" "), (!_vm.SBDetail.cargoGrossWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.cargoGrossWeight))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Measurement(CBM)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "measurementCBM",
      "id": "measurementCBM"
    },
    model: {
      value: (_vm.SBDetail.measurementCBM),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "measurementCBM", $$v)
      },
      expression: "SBDetail.measurementCBM"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Net Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "netWeight",
      "name": "netWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.SBDetail.netWeight),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "netWeight", $$v)
      },
      expression: "SBDetail.netWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('label', {
    attrs: {
      "for": "weightUnit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.unitList,
      "option-value": "uV",
      "option-text": "uT",
      "placeholder": "Select",
      "name": "weightUnit",
      "id": "weightUnit"
    },
    model: {
      value: (_vm.SBDetail.weightUnit),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "weightUnit", $$v)
      },
      expression: "SBDetail.weightUnit"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Package Details")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageNameList,
      "id": "clientId",
      "option-value": "packageId",
      "option-text": "packageName",
      "placeholder": "Select  Package Name"
    },
    model: {
      value: (_vm.SBDetail.packageId),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "packageId", $$v)
      },
      expression: "SBDetail.packageId"
    }
  }), _vm._v(" "), (!_vm.SBDetail.packageId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMainExecution.packageId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No of " + _vm._s(_vm.SBDetail.packageName))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "noOfpkgUnit",
      "id": "noOfpkgUnit",
      "type": "number",
      "min": "0",
      "disabled": _vm.SBDetail.packageName == '' ? true : false
    },
    model: {
      value: (_vm.SBDetail.noOfpkgUnit),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "noOfpkgUnit", $$v)
      },
      expression: "SBDetail.noOfpkgUnit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("LEEO (Let Export Permit) Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "leeoDate",
      "id": "leeoDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.leeoDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "leeoDate", $$v)
      },
      expression: "SBDetail.leeoDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("LEEO (Let Export Permit) No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "leeoNo",
      "id": "leeoNo"
    },
    model: {
      value: (_vm.SBDetail.leeoNo),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "leeoNo", $$v)
      },
      expression: "SBDetail.leeoNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Invoice From Client")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "placeholder": "Click to Upload  Invoice From Client",
      "name": "invoiceUpload",
      "id": "invoiceUpload",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangeInvoice
    },
    model: {
      value: (_vm.SBDetail.invoiceUpload),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "invoiceUpload", $$v)
      },
      expression: "SBDetail.invoiceUpload"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Cargo Packing List")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "placeholder": "Click to Upload Cargo Packing List",
      "name": "cargoUpload",
      "id": "cargoUpload",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangeCargo
    },
    model: {
      value: (_vm.SBDetail.cargoUpload),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "cargoUpload", $$v)
      },
      expression: "SBDetail.cargoUpload"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "variant": "outline-info",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addSBDetail
    }
  }, [_vm._v(_vm._s(_vm.SBDetail.conshippingSBId == "" ? "Add" : "Edit") + " S/B\n                    Detail")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1)], 1), _vm._v(" "), (_vm.viewInvoicedDoc.length > 0 || _vm.viewCargoDoc.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _vm._l((_vm.viewInvoicedDoc), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "20"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/FFExecutionSBWareHouse/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document -\n                    " + _vm._s(index + 1))])])
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _vm._l((_vm.viewCargoDoc), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "20"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/FFExecutionSBWareHouse/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document -\n                    " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.clientSBMultipleArry.length > 0) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.clientSBMultipleArry.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("All Client Shipping Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ffConClientSB"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping Bill No")]), _vm._v(" "), _c('th', [_vm._v("Remove")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.clientSBMultipleArry), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEditSB(item)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.myclientName) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEditSB(item)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.shippingBillNo) + "\n                      ")]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": item.Status == true
      },
      on: {
        "click": function($event) {
          _vm.removeCommon(item)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), (
    _vm.sbLengthforAll.length == _vm.getMultipleClientArry.length &&
    _vm.getMultipleClientArry.length > 0
  ) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), (_vm.getMultipleClientArry.length > 0 && _vm.proceedNext == '1') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderRail"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('VGM')
      }
    }
  }, [_vm._v("Save &\n                  Proceed to VGM")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderRail"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.sbLengthforAll.length == _vm.getMultipleClientArry.length &&
    _vm.getMultipleClientArry.length > 0 && _vm.proceedNext == '1'
  ) ? _c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.proceedNext == '1') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('BLRaised')
      }
    }
  }, [_vm._v("Save & Proceed to raise\n                  B/L")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.sbLengthforAll.length == _vm.getMultipleClientArry.length &&
    _vm.getMultipleClientArry.length > 0 && _vm.proceedNext == '1'
  ) ? _c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.proceedNext == '1') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderRail"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('handover')
      }
    }
  }, [_vm._v(_vm._s(_vm.ffExportDetail.portType == "Icd" ?
    "Save & Proceed to Handover to Rail" :
    "Save & Proceed to Gate ­ in at Terminal By Road"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderRail"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.sbLengthforAll.length == _vm.getMultipleClientArry.length &&
    _vm.getMultipleClientArry.length > 0 && _vm.proceedNext == '1'
  ) ? _c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.proceedNext == '1') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.AppovalMSG))]), _c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('PAYTEST')
      }
    }
  }, [_vm._v("Save & Proceed to Sline Payment")]), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderRail"
    }
  }), _vm._v(" "), (_vm.WarehouseStuffing.allModuleId && _vm.is_approval_mail_action > 0) ? _c('ResetSlineSubscription', {
    attrs: {
      "allModuleId": Number(_vm.WarehouseStuffing.allModuleId),
      "JobNo": _vm.WarehouseStuffing.ffExportFclConsoSeries
    },
    on: {
      "refresh-data": _vm.getData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.WarehouseStuffing.allModuleId && _vm.is_approval_mail_action > 0) ? _c('br') : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "md-gutter": ""
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop3",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseSBDetails
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1c0278","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ffExportCon/executionWHStuffingIcdCon.vue
// module id = 2618
// module chunks = 0